import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconWithdrawCashProps } from './IconWithdrawCash.types'
import * as Styled from './styles/IconWithdrawCash.style'

import { nonThemeableRules } from '../../ruleSet'

const IconWithdrawCash: FC<IconWithdrawCashProps> = ({
  size = nonThemeableRules.defaultSize as number as IconWithdrawCashProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconWithdrawCashProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path
            d='M4.293 9.031h-.027c-.965 0-1.75-.785-1.75-1.75V4.27c0-.97.785-1.75 1.75-1.75h17.226v4.76c-.156.953-.785 1.75-1.75 1.75M4.512 6.047h14.984'
            vectorEffect='non-scaling-stroke'
          />
          <path d='M12.984 8.695a.98.98 0 0 1-1.96 0c0-.539.44-.98.98-.98.539 0 .98.441.98.98Zm0 0' vectorEffect='non-scaling-stroke' />
          <path d='M19.5 6.05v6.106c0 .485-.39.875-.875.875H5.387a.874.874 0 0 1-.875-.875v-6.11' vectorEffect='non-scaling-stroke' />
          <path
            d='M7.48 11.34c0-.668-.543-1.211-1.214-1.211V7.262c.671 0 1.214-.543 1.214-1.211h9.051c0 .668.543 1.21 1.211 1.21v2.864c-.668 0-1.21.543-1.21 1.21Zm4.524 10.16v-5.969m-2.25 3.719 2.25 2.25 2.25-2.25'
            vectorEffect='non-scaling-stroke'
          />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconWithdrawCash
